import { EventCategory } from "@/domains/-community/-events/models/event";
import { ResourceType } from "@/domains/-community/-resources/models/resource";
import { Target } from "@/functions/addToCalendar";
import { Lang } from "@/sdk";

declare global {
    interface Window { plausible: any; }
}

export function initAnalytics(){
    //Plausible Analytics initializing

    var script = document.createElement('script');
    script.defer = true;
    script.dataset.domain = "omind.me";
    script.dataset.api = "https://plausible.io/api/event";
    script.src = "https://plausible.io/js/script.manual.tagged-events.js";
    document.getElementsByTagName('head')[0].appendChild(script);

    window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }
}

export type AnalyticsEvent = 'SignIn' | 'Resource' | 'OmindEvent' | 'Coach' | 'Page Community' | 'News Link'

export function pushAnalyticsEvent(event: AnalyticsEvent, props: any){
    window.plausible(event, {props: props})
}

export function pushSignInEvent(props: {
    lang: Lang
}){
    pushAnalyticsEvent('SignIn', props)
}

export function pushResourceEvent(props: {
    resourceType: ResourceType,
    resource: string,
    lang: Lang
}){
    pushAnalyticsEvent('Resource', props)
}

export function pushSaveTheDateEvent(props: {
    eventCategory: EventCategory,
    event: string,
    lang: Lang,
    target: Target
}){
    pushAnalyticsEvent('OmindEvent', props)
}

export function pushNewsLinkEvent(props: {
    news: string,
    lang: Lang
}){
    pushAnalyticsEvent('News Link', props)
}

export function pushCommunityEvent(props: {
    lang: Lang
}){
    pushAnalyticsEvent('Page Community', props)
}